<template>
  <v-combobox
    v-model="selectedContacts"
    solo
    :disabled="commentType == 'ticket_reply_to_email'"
    :multiple="commentType !== 'ticket_reply_to_email'"
    hide-details
    :small-chips="commentType !== 'ticket_reply_to_email'"
    dense
    :items="contactList"
    item-text="email"
    item-value="email"
    :return-object="false"
    :no-filter="true"
    deletable-chips
    class="mt-0"
    :search-input.sync="searchKeyword"
    :append-outer-icon="emailType !== 'to_email' ? 'mdi-close' : ''"
    v-track="'search-contact-field'"
    @input="sendValue"
    @click:append-outer="removeColumn('cc-email')"
    attach
  >
    <template v-slot:item="{ item }" v-if="contactList.length">
      <div v-if="item" class="text-truncate width-100">
        <span class="body-2" v-if="item.first_name || item.last_name">
          {{ item.first_name ? item.first_name : "" | upperCaseFirst }}
          {{ item.last_name ? item.last_name : "" }}
          <span class="grey--text text--darken-2 pl-2">
            {{ item.email | upperCaseFirst }}</span
          >
        </span>
        <span v-else class="grey--text text--darken-2 pl-2 body-2">
          {{ item.email | upperCaseFirst }}
        </span>
      </div>
    </template>
    
    <template v-if="commentType !== 'ticket_reply_to_email'" v-slot:selection="{ item, index }">
      <template v-if="commentType !== 'ticket_reply'">
        <v-chip v-if="index === 0" close  @click:close="deleteChip(item)"
          v-track="'delete-selected-contact'">
          <span class="text-truncate"> {{ item }} </span>
        </v-chip>
        <span v-if="index === 1" class="grey--text text--darken-2 text-caption">
          (+{{ selectedContacts.length - 1 }} more)
        </span>
      </template>
      <template v-else>
        <v-chip close  @click:close="deleteChip(item)"
          v-track="'delete-selected-contact'">
          <span class="text-truncate"> {{ item }} </span>
        </v-chip>
      </template>
    </template>
  </v-combobox>
</template>

<script>
import { $contacts } from "@/services/Index";

export default {
  props: {
    emailType:{
      type: String,
      required: true
    }, 
    defaultValue:{
      type: [Object, Array],
      default: ()=> ([])
    },
    selectedList:{
      type: [Object, Array],
      default: ()=> ([])
    }, 
    existingEmails:{
      type: [Object, Array],
      default: ()=> ([])
    }, 
    commentType:{
      type: String,
      required: true
    } 
  },
  data() {
    return {
      selectedContacts: [],
      contactList: [],
      contactsPerPage: 50,
      pageNo: 1,
      searchKeyword: null,
    };
  },

  watch: {
    searchKeyword(val) {
      if (val && val.length >= 2) {
        let searchVal = val;
        this.getContactList(searchVal);
      }
    },
  },

  mounted() {
    let toEmail = this.defaultValue;
    if (this.commentType == "ticket_reply_to_email") {
      this.selectedContacts = toEmail[0];
    }
    if (this.selectedList.length) {
      this.selectedContacts = this.selectedList;
    }
  },

  methods: {
    deleteChip(item) {
      this.selectedContacts = this.selectedContacts.filter((x) => x !== item);
      this.sendValue();
    },
    
    sendValue() {
      if (this.emailType === "cc" || this.emailType === "bcc") {
          this.selectedContacts = this.selectedContacts.filter(email =>
              !this.defaultValue.includes(email) && !this.existingEmails.includes(email)
          );
      }
      this.$emit("getValue", this.selectedContacts);
    },

    removeColumn() {
      this.$emit("removeColumn");
    },
    /** get contact list data from API's */
    getContactList(searchVal = "") {
      const data = {
        per_page: this.contactsPerPage,
        page: this.pageNo,
        q: {
          email_cont: searchVal,
          m: "or",
        },
      };
      $contacts
        .fetchList(data, {})
        .then((response) => {
          this.contactList = response.data.contacts;
        })
        .catch(() => {
          //   this.isLoading = false;
        });
    },
  },
};
</script>
